export default __webpack_public_path__ + "static/files/天唯士慢病管理平台v1.2.0912d39d.pdf";